var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
      on: {
        submit: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("h2", { staticClass: "mb-10" }, [
        _vm._v("Formulario de Aumento de plazo")
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "label",
          { staticClass: "col-4 col-form-label", attrs: { for: "empresa" } },
          [_vm._v("Empresa")]
        ),
        _c("div", { staticClass: "col-4", attrs: { "data-cy": "company" } }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.empresa,
                  expression: "formData.empresa"
                }
              ],
              staticClass: "form-control",
              attrs: { id: "empresa" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.formData,
                    "empresa",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "aguasandinas" } }, [
                _vm._v("Aguas Andinas")
              ]),
              _c("option", { attrs: { value: "cordillera" } }, [
                _vm._v("Cordillera")
              ]),
              _c("option", { attrs: { value: "manquehue" } }, [
                _vm._v("Manquehue")
              ])
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "label",
          { staticClass: "col-4 col-form-label", attrs: { for: "titulo" } },
          [_vm._v("Titulo Destinatario")]
        ),
        _c(
          "div",
          { staticClass: "col-4", attrs: { "data-cy": "recipient-title" } },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.tituloDestinatario,
                    expression: "formData.tituloDestinatario"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "titulo" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.formData,
                      "tituloDestinatario",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "sr" } }, [_vm._v("Señor")]),
                _c("option", { attrs: { value: "sra" } }, [_vm._v("Señora")]),
                _c("option", { attrs: { value: "srta" } }, [_vm._v("Señorita")])
              ]
            )
          ]
        )
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-6", attrs: { "data-cy": "recipient's-name" } },
          [
            _c("vs-input", {
              staticClass: "w-full",
              attrs: {
                label: "Nombre del destinatario",
                type: "text",
                id: "nombreDestinatario"
              },
              model: {
                value: _vm.formData.nombreDestinatario,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "nombreDestinatario", $$v)
                },
                expression: "formData.nombreDestinatario"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("vs-input", {
              staticClass: "w-full",
              attrs: {
                label: "Cargo del destinatario",
                type: "text",
                id: "cargoDestinatario",
                "data-cy": "recipient-position"
              },
              model: {
                value: _vm.formData.cargoDestinatario,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "cargoDestinatario", $$v)
                },
                expression: "formData.cargoDestinatario"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-6", attrs: { "data-cy": "user-step" } },
          [
            _c("list-user", {
              ref: "author",
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: "Firmante",
                name: "userStep",
                id: "nombreAutor"
              },
              on: { "set-position": _vm.setPosition },
              model: {
                value: _vm.formData.nombreAutor,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "nombreAutor", $$v)
                },
                expression: "formData.nombreAutor"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("vs-input", {
              staticClass: "w-full",
              attrs: {
                label: "Cargo firmante",
                type: "text",
                id: "cargoAutor",
                "data-cy": "signatory-position"
              },
              model: {
                value: _vm.formData.cargoAutor,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "cargoAutor", $$v)
                },
                expression: "formData.cargoAutor"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("vs-input", {
              staticClass: "w-full",
              attrs: {
                label: "Referencia",
                type: "text",
                id: "referencia",
                "data-cy": "reference"
              },
              model: {
                value: _vm.formData.referencia,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "referencia", $$v)
                },
                expression: "formData.referencia"
              }
            }),
            _vm.hasReference
              ? _c("div", { staticClass: "text-right" }, [
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Contador de caracteres",
                          expression: "'Contador de caracteres'"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.formData.referencia.length) +
                          " caracteres "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-full",
              attrs: {
                label: "Materia",
                type: "text",
                name: "materia",
                danger: _vm.errors.has("custom-document.materia"),
                "danger-text": _vm.errors.first("custom-document.materia"),
                "data-cy": "subject"
              },
              model: {
                value: _vm.formData.materia,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "materia", $$v)
                },
                expression: "formData.materia"
              }
            }),
            _vm.hasMatter
              ? _c("div", { staticClass: "text-right" }, [
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Contador de caracteres",
                          expression: "'Contador de caracteres'"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.formData.materia.length) + " caracteres"
                      )
                    ]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("vs-input", {
              staticClass: "w-full",
              attrs: {
                label: "Incluye",
                type: "text",
                id: "inc",
                "data-cy": "includes"
              },
              model: {
                value: _vm.formData.inc,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "inc", $$v)
                },
                expression: "formData.inc"
              }
            }),
            _vm.hasInc
              ? _c("div", { staticClass: "text-right" }, [
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Contador de caracteres",
                          expression: "'Contador de caracteres'"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(_vm.formData.inc.length) + " caracteres")]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("label", [
              _vm._v(
                "En atención a vuestro oficio de la referencia, relativo a:"
              )
            ]),
            _c("vs-textarea", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-full mb-0",
              attrs: { type: "text", name: "motivo", "data-cy": "reason" },
              model: {
                value: _vm.formData.motivo,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "motivo", $$v)
                },
                expression: "formData.motivo"
              }
            }),
            _vm.errors.first("custom-document.motivo")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                    staticStyle: { height: "32px" }
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.errors.first("custom-document.motivo")) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm.hasReason
              ? _c("div", { staticClass: "text-right" }, [
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Contador de caracteres",
                          expression: "'Contador de caracteres'"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(_vm.formData.motivo.length) + " caracteres")]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-full",
              attrs: {
                label: "Plazo en días hábiles",
                type: "number",
                name: "plazo",
                danger: _vm.errors.has("custom-document.plazo"),
                "danger-text": _vm.errors.first("custom-document.plazo"),
                "data-cy": "number"
              },
              model: {
                value: _vm.formData.plazo,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "plazo", $$v)
                },
                expression: "formData.plazo"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "label",
          { staticClass: "col-4 col-form-label", attrs: { for: "empresa" } },
          [_vm._v(" ¿Quiere escribir el motivo de la prórroga? ")]
        ),
        _c("div", { staticClass: "col-4" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.esMotivoDeProrroga,
                  expression: "formData.esMotivoDeProrroga"
                }
              ],
              staticClass: "form-control",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.formData,
                    "esMotivoDeProrroga",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "si" } }, [_vm._v("Si")]),
              _c("option", { attrs: { value: "no" } }, [_vm._v("No")])
            ]
          )
        ])
      ]),
      _vm.hasExtend
        ? _c("div", { staticClass: "form-group row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("label", [_vm._v("Motivo de la prórroga ")]),
                _c("vs-textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "w-full mb-0",
                  attrs: {
                    type: "text",
                    name: "motivoProrroga",
                    "data-vv-as": "motivo de la prórroga",
                    "data-cy": "reason-for-extension"
                  },
                  model: {
                    value: _vm.formData.motivoProrroga,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "motivoProrroga", $$v)
                    },
                    expression: "formData.motivoProrroga"
                  }
                }),
                _vm.errors.first("custom-document.motivoProrroga")
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                        staticStyle: { height: "32px" }
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.errors.first(
                                  "custom-document.motivoProrroga"
                                )
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.hasReason
                  ? _c("div", { staticClass: "text-right" }, [
                      _c(
                        "small",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Contador de carácteres",
                              expression: "'Contador de carácteres'"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formData.motivoProrroga.length) +
                              " carácteres "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "form-group row" }, [
        _c(
          "div",
          { staticClass: "col-10" },
          [
            _c("vs-input", {
              staticClass: "w-full",
              attrs: {
                label: "Con copia a",
                type: "text",
                id: "copia",
                "data-cy": "with-copy"
              },
              model: {
                value: _vm.formData.copia,
                callback: function($$v) {
                  _vm.$set(_vm.formData, "copia", $$v)
                },
                expression: "formData.copia"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "row justify-end" },
        [
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: { color: "primary", type: "border", disabled: _vm.saving },
              on: {
                click: function($event) {
                  return _vm.back()
                }
              }
            },
            [_vm._v(" Cancelar ")]
          ),
          _c(
            "vs-button",
            {
              staticClass: "mt-5 mr-5",
              attrs: {
                color: "primary",
                type: "border",
                disabled: _vm.saving,
                "data-cy": "save"
              },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [
              _vm._v(" Crear "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.saving,
                    expression: "saving"
                  }
                ],
                staticClass: "spinner-border spinner-border-sm text-primary"
              })
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }